var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PICButton_IS_DEFAULT_WIDTH;
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { styleMap } from 'lit/directives/style-map.js';
import { property, query } from 'lit/decorators.js';
import { html, css } from 'lit';
import { stringDecoder, stringDecoderLC, objectDecoder, booleanDecoder, PICAction, customElement, loadPage, PICBase, PIC, submitEventHandler, PICModal, Util, base64Decoder } from '../Internals';
import "../Base/PICToolTip";
let PICButton = class PICButton extends PICBase {
    constructor() {
        super(...arguments);
        this.label = '';
        this.cb = '';
        this.loadPagePath_ = '';
        this.loadPageParm_ = '';
        this.loadPageOpt_ = {};
        this.tmpParam_ = null;
        this.eType = 'old';
        this.density = 'old';
        this.densitymargin = 'old';
        this.alignRight_ = false;
        this.buttonIcon = '';
        this.Iconalign = '';
        this.focus_ = false;
        this.eventstyle = undefined;
        this.isSubmit_ = false;
        this._width = '96px';
        _PICButton_IS_DEFAULT_WIDTH.set(this, false);
        this.noPadding = false;
    }
    set isSubmit(iSubmit) {
        this.isSubmit_ = iSubmit;
        if (iSubmit) {
            //web 3 in modal
            if (this.getRootNode().firstElementChild instanceof PICModal) {
                this.getRootNode().firstElementChild.submitButton = this;
            }
            else
                PIC.getInstance.setSubmitButton(this);
        }
    }
    get isSubmit() {
        return this.isSubmit_;
    }
    set width(iwidth) {
        let widthParser = '96px';
        if (typeof iwidth == 'number' || iwidth.match(/^-?[0-9]*$/g)) {
            iwidth = parseFloat(iwidth); //Number() instead of parseFloat?
            if (iwidth === -1)
                __classPrivateFieldSet(this, _PICButton_IS_DEFAULT_WIDTH, true, "f");
            if (iwidth < 96)
                iwidth = 96;
            widthParser = iwidth + 'px';
        }
        else
            widthParser = iwidth;
        this._width = widthParser;
        this.requestUpdate();
    }
    get width() {
        return this._width;
    }
    set action(iObj) {
        if (iObj instanceof PICAction) {
            this.action_ = iObj;
        }
        else {
            this.action_ = new PICAction();
            this.action_.actionOptions = iObj;
            this.action_.boundElm = this;
        }
    }
    get action() {
        return this.action_;
    }
    static get styles() {
        //TODO: refractor stupidly complex css
        const defaultStyle = css `
            :host{
/*              padding-top: 0.85rem;
                padding-left: 0.1rem;*/
                
                display: inline-block;
                padding-bottom: 1px;
                --pic-buttonBGColor: var(--pic-surfaceColor);
                --pic-buttonColor: var(--pic-primaryColor);
                --pic-buttonHoverBGColor: var(--pic-primaryHoverColor);
                --pic-buttonFocusBGColor: var(--pic-primaryFocusColor);
                --pic-buttonActiveBGColor: var(--pic-primaryActiveColor);
                --pic-buttonActiveColor: var(--pic-primaryColor);
                --pic-buttonDisabledBGColor: var(--pic-primaryActiveColor);
                --pic-buttonDisabledColor: var(--pic-disabledBGColor);
                --pic-buttonDiabledBorderColor: var(--pic-borderColor);
                --pic-buttonOutlinedBorderColor: var(--pic-borderColor);
                --pic-buttonContainedBGColor: var(--pic-buttonContainedBGColorOverride, var(--pic-primaryColor));
                --pic-buttonContainedColor: var(--pic-onPrimaryColor, var(--pic-surfaceColor));
                --pic-buttonContainedHoverBGColor: 
                    linear-gradient(to right, var(--pic-whiteOverlayHoverColor), var(--pic-whiteOverlayHoverColor)),
                    linear-gradient(to right, var(--pic-buttonContainedBGColor), var(--pic-buttonContainedBGColor));
                --pic-buttonContainedFocusBGColor: 
                    linear-gradient(to right, var(--pic-whiteOverlayFocusColor), var(--pic-whiteOverlayFocusColor)),
                    linear-gradient(to right, var(--pic-primaryColor), var(--pic-primaryColor));
                --pic-buttonContainedActiveBGColor: 
                    linear-gradient(to right, var(--pic-whiteOverlayActiveColor), var(--pic-whiteOverlayActiveColor)),
                    linear-gradient(to right, var(--pic-primaryColor), var(--pic-primaryColor));
                --pic-buttonContainedDisabledBGColor: var(--pic-disabledBGColor);
                --pic-buttonContainedDisabledColor: var(--pic-onSurfaceDisabledColor);
                height: min-content;
                /* min-width: var(--elmWidth); */
                width: max-content;
            }
            .pic-button-container {
                display: flex;
                align-items: center;
                justify-content: center;               
            }
            .pic-button-old:hover {
                background: var(--buttonHoverColor);
                color: black;
            }
            .pic-button-old {
                text-align: center;
                font-size: 1em;
                width: 100%;
                background: var(--buttonColor);
                border: 1px solid black;
                color: white;
                height: 30px;
                padding: 0px 8px;
            }

            .pic-button{
                color: var(--pic-buttonColor);
                max-height: 36px;
                padding: 10px 14px;
            }
            .pic-button.contained{
                color: var(--pic-buttonContainedColor);
                background-color: var(--pic-buttonContainedBGColor);
                box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2);
                border-radius: 4px;
            }
            .pic-button.outlined{
                box-shadow:inset 0px 0px 0px 1px var(--pic-buttonOutlinedBorderColor);
                border-radius: 4px;
            }
            .pic-button.low{
                /*margin-top: 29px;*/
            }
            .pic-button.medium{
                /*margin-top: 28px;*/
                max-height: 28px;
                padding: 6px 14px;
            }
            .pic-button.high{
                /*margin-top: 11px;*/
                min-height: 24px;
                padding: 0 2px;
            }
            .noPadding {
                padding: 0;
            }
            .pic-button b{
                padding-left: 8px;
                padding-right: 8px;
                overflow: hidden;
                white-space: nowrap;
            }
            
            .pic-button.disabled{
                color: var(--pic-buttonDisabledColor);
                /* pointer-events: none; */
            }
            .pic-button-container.contained.disabled{
                background-color: var(--pic-buttonContainedDisabledBGColor);
                color: var(--pic-buttonContainedDisabledColor);
                /* pointer-events: none; */
            }
            .pic-button:hover:not(.disabled){
                cursor: pointer;
                background-color: var(--pic-buttonHoverBGColor);
                border-radius: 4px;
            }
            .pic-button.contained:hover:not(.disabled){
                background-color: unset;
                background-image: var(--pic-buttonContainedHoverBGColor);
                box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
                /* make sure shadow is over other elements */
                z-index: 1;
                position: relative;
            }
            .pic-button:focus{
                background-color: var(--pic-buttonFocusBGColor);
                border-radius: 4px;
                outline: none;
            }
            .pic-button.contained:focus{
                background-color: unset;
                background-image: var(--pic-buttonContainedFocusBGColor);
                box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
                outline: none;
                /* make sure shadow is over other elements */
                z-index: 1;
                position: relative;
            }
            .pic-button:active:not(.disabled){
                background-color: var(--pic-buttonActiveBGColor);
                border-radius: 4px;
                color: var(--pic-buttonActiveColor);
                outline: none;
            }
            .pic-button.contained:active:not(.disabled){
                background-color: unset;
                background-image: var(--pic-buttonContainedActiveBGColor);
                box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12), 0px 3px 5px rgba(0, 0, 0, 0.2);
                color: var(--pic-buttonContainedColor);
                outline: none;
                /* make sure shadow is over other elements */
                z-index: 1;
                position: relative;
            }
            .pic-button-container.icon.high{
                padding-left: 6px;
            }
            .pic-button.icon::before{
                content: "+";
            }

        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.tmpParam_) {
            this.action = new PICAction();
        }
    }
    firstUpdated() {
        if (this.alignRight_)
            this.style.marginLeft = 'auto';
        if (this.tmpParam_) {
            this.action.type_ = 'internal';
            this.action.eventFnc = this.openModal.bind(this);
        }
        if (this.density === 'high')
            this.densitymargin = 'high';
        if (this.focus_)
            this.focus();
    }
    openModal() {
        let ulm = document.createElement('pic-uploadmodal');
        for (let prop in this.tmpParam_) {
            ulm.setAttribute(prop, this.tmpParam_[prop]);
        }
        document.body.appendChild(ulm);
        ulm.isHidden = false;
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    handleKey(e) {
        if (['Enter', ' '].includes(e.key)) {
            this.doEvent(e);
        }
    }
    handleClick(e) {
        if (!this.disabled_) {
            if (this.eventstyle === 'js') {
                this.dispatchEvent(new CustomEvent(`js${e.type}`, { detail: e, bubbles: true }));
                return;
            }
            Util._throttle(this, this.doEvent, 1000, false)(e);
        }
    }
    focus() {
        if (this.innerbtn)
            this.innerbtn.focus();
    }
    doEvent(e) {
        var _a, _b, _c, _d, _e;
        if (this.loadPagePath_) {
            try {
                if (!this.loadPageOpt_.parentSessId) {
                    let parentRoot = this.getRootNode();
                    if (parentRoot instanceof DocumentFragment) {
                        let shadow = parentRoot;
                        if (shadow.host.nodeName === 'PIC-LOADPAGE')
                            this.loadPageOpt_.parentSessId = shadow.host.selfSessId;
                    }
                }
            }
            catch (_f) { }
            let lp = document.querySelector('pic-loadpage');
            //if modal is already open, move focus to its first element
            if (lp && lp.apiurl === this.loadPagePath_) {
                if (((_a = lp.shadowRoot) === null || _a === void 0 ? void 0 : _a.children.item(0)) && ((_c = (_b = lp.shadowRoot) === null || _b === void 0 ? void 0 : _b.children.item(0)) === null || _c === void 0 ? void 0 : _c.nodeName) === 'PIC-MODAL') {
                    let firstItem, modalItems = (_e = (_d = lp.shadowRoot) === null || _d === void 0 ? void 0 : _d.children.item(0)) === null || _e === void 0 ? void 0 : _e.querySelectorAll('[piccomponent]:not([disabled]), input[type="button"]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])');
                    if (modalItems && modalItems.length > 0) {
                        firstItem = modalItems[0];
                        firstItem.focus();
                    }
                    ;
                }
            }
            else
                loadPage(this.loadPagePath_, this.loadPageParm_, this.loadPageOpt_);
        }
        else if (this.cb > '') {
            submitEventHandler(e, this.eventId_);
        }
        else if (this.action != null) {
            this.action.triggerEvent(e);
        }
        else
            submitEventHandler(e, this.eventId_);
    }
    getButtonClass() {
        let classinfo = {
            'pic-button': true,
            'pic-button-container': true,
            'pic-button-old': this.eType == 'old' || this.eType == undefined,
            'disabled': this.disabled_
        };
        //eType can have two parts
        let eTypeArr = this.eType.split('-');
        classinfo[eTypeArr[0]] = true;
        if (eTypeArr.length == 2)
            classinfo[eTypeArr[1]] = true;
        classinfo[this.density] = true;
        return classinfo;
    }
    getBTagPadding() {
        let styles = [];
        styles.push({ 'padding': '0 8px' });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    getDivWidth() {
        let styles = [];
        styles.push({ 'width': 'auto' });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    /*getButtonStyle(){
        if(this.width !== -1) return {'width': '' + this.width + 'px'}
        return {}
    }*/
    /*style=${styleMap(this.getButtonStyle())}*/
    setComponentInlineStyle() {
        this.style.setProperty('min-width', this.width);
        if (!__classPrivateFieldGet(this, _PICButton_IS_DEFAULT_WIDTH, "f")) {
            this.style.setProperty('width', this.width);
            this.style.setProperty('max-width', this.width);
        }
    }
    getLogoStyle(iSize) {
        let styles = [];
        if (this.buttonIcon && this.label)
            if (this.Iconalign == 'right')
                styles.push({ 'padding-right': iSize });
            else
                styles.push({ 'padding-left': iSize });
        return styles.length > 0 ? styles.reduce((total, current) => total = Object.assign(Object.assign({}, total), current)) : {};
    }
    render() {
        const tabby = this.disabled_ ? undefined : "0";
        this.setComponentInlineStyle();
        return html `
            ${this.renderCSS(true)}
            <div 
                ?disabled=${this.disabled_} 
                tabindex=${ifDefined(tabby)}
                class=${classMap(this.getButtonClass())}
                style=${styleMap(this.getDivWidth())}
                @click=${this.handleClick}
                @keyup=${this.handleKey}>
                
                ${this.Iconalign == 'right' ?
            html `
                        ${this.label ? html `<b style=${styleMap(this.getLogoStyle('4px'))}>${this.label}</b>` : ''}
                        ${this.buttonIcon ? html `<i style=${styleMap(this.getLogoStyle('8px'))} class=${this.buttonIcon}></i>` : ''}
                    ` :
            html `
                        ${this.buttonIcon ? html `<i style=${styleMap(this.getLogoStyle('8px'))} class=${this.buttonIcon}></i>` : ''}
                        ${this.label ? html `<b style=${styleMap(this.getLogoStyle('4px'))}>${this.label}</b>` : ''}
                    `}
        </div>
        ${this.tooltip_ ? html `<pic-tooltip>${this.tooltip_}</pic-tooltip>` : ''}
        `;
    }
};
_PICButton_IS_DEFAULT_WIDTH = new WeakMap();
__decorate([
    query('.pic-button')
], PICButton.prototype, "innerbtn", void 0);
__decorate([
    property({ converter: stringDecoder })
], PICButton.prototype, "label", void 0);
__decorate([
    property()
], PICButton.prototype, "cb", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'loadpagepath' })
], PICButton.prototype, "loadPagePath_", void 0);
__decorate([
    property({ converter: base64Decoder, attribute: 'loadpageparm' })
], PICButton.prototype, "loadPageParm_", void 0);
__decorate([
    property({ converter: objectDecoder, attribute: 'loadpageopt' })
], PICButton.prototype, "loadPageOpt_", void 0);
__decorate([
    property({ converter: objectDecoder, attribute: 'tmpparms' })
], PICButton.prototype, "tmpParam_", void 0);
__decorate([
    property({ converter: stringDecoderLC, attribute: 'etype' })
], PICButton.prototype, "eType", void 0);
__decorate([
    property({ converter: stringDecoderLC, attribute: 'density' })
], PICButton.prototype, "density", void 0);
__decorate([
    property({ converter: stringDecoderLC, reflect: true, attribute: 'densitymargin' })
], PICButton.prototype, "densitymargin", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'alignright' })
], PICButton.prototype, "alignRight_", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'icon' })
], PICButton.prototype, "buttonIcon", void 0);
__decorate([
    property({ converter: stringDecoder, attribute: 'iconalign' })
], PICButton.prototype, "Iconalign", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'focus' })
], PICButton.prototype, "focus_", void 0);
__decorate([
    property()
], PICButton.prototype, "eventstyle", void 0);
__decorate([
    property({ converter: booleanDecoder, attribute: 'submit' })
], PICButton.prototype, "isSubmit", null);
__decorate([
    property({ type: String, attribute: 'width', reflect: false })
], PICButton.prototype, "width", null);
__decorate([
    property({ converter: objectDecoder, attribute: 'action', reflect: true })
], PICButton.prototype, "action", null);
PICButton = __decorate([
    customElement('pic-button')
], PICButton);
export { PICButton };
//# sourceMappingURL=PICButton.js.map